import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Button } from '@/components/ui-kit/button';
import { LOGIN_COLORS } from '@/modules/auth/constants/login-theme';

const successIcon = '/assets/images/verification-success.svg';

export function ActivationSuccessPage() {
  const { t } = useTranslation();

  return (
    <div className="flex w-full flex-col gap-8">
      <div className="flex justify-center">
        <img src={successIcon} alt="" className="h-14 w-32" />
      </div>

      <div className="flex flex-col gap-3">
        <h2
          className="break-words text-[2rem] font-bold leading-tight tracking-tight sm:text-[2.125rem]"
          style={{ color: LOGIN_COLORS.textPrimary }}
        >
          {t('ACCOUNT_ACTIVATED_SUCCESSFULLY')}
        </h2>
        <p className="text-base font-normal leading-6" style={{ color: LOGIN_COLORS.textMuted }}>
          {t('CONTINUE_LOGIN_SSO')}
        </p>
      </div>

      <Link to="/login" className="w-full">
        <Button
          className="h-12 w-full rounded-xl border-0 text-sm font-semibold shadow-none hover:opacity-90"
          size="lg"
          type="button"
          style={{ backgroundColor: LOGIN_COLORS.primary, color: LOGIN_COLORS.pureWhite }}
        >
          {t('LOG_IN')}
        </Button>
      </Link>
    </div>
  );
}
